import { getPlpBrowseTagsForApi } from '@/features/plp/utils/plpUrl';

/** Browse `tags` from a filter item URL (canonical order from API). */
export function getPlpTagsFromFilterItemUrl(url: string): string {
  const trimmed = url.trim();
  if (!trimmed) return '';

  try {
    let pathname: string;
    let searchString: string;

    if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) {
      const parsed = new URL(trimmed);
      pathname = parsed.pathname;
      searchString = parsed.search;
    } else {
      const qIdx = trimmed.indexOf('?');
      pathname = qIdx >= 0 ? trimmed.slice(0, qIdx).split('#')[0] : trimmed.split('#')[0];
      searchString = qIdx >= 0 ? trimmed.slice(qIdx) : '';
    }

    // Search-style filter item URLs encode the selected filter in a `tags` query param
    // (e.g. /search?search_query=earrings&tags=rings). Extract it before falling back to
    // pathname-based extraction which would otherwise return the default 'jewellery'.
    if (searchString) {
      const tagsParam = new URLSearchParams(searchString).get('tags');
      if (tagsParam?.trim()) return tagsParam.trim();
    }

    return getPlpBrowseTagsForApi(pathname);
  } catch {
    return getPlpBrowseTagsForApi(trimmed.split('?')[0].split('#')[0]);
  }
}

/** Tags for `/listing/filters` preview — use the toggled item URL from the API. */
export function getPlpFilterPreviewTags(
  filterItemUrl: string | null | undefined,
  fallbackTags: string
): string {
  if (!filterItemUrl?.trim()) return fallbackTags;
  return getPlpTagsFromFilterItemUrl(filterItemUrl) || fallbackTags;
}
